module.exports = __webpack_public_path__ + "img/kucun.a7380036.png";